import { Injectable, OnDestroy } from "@angular/core";
import { DataSource } from "@angular/cdk/table";
import { BehaviorSubject, merge, Observable, Subscription } from "rxjs";
import { CollectionViewer } from "@angular/cdk/collections";
import { map } from "rxjs/operators";
import { TreeListService } from "./tree-list.service";
import { TreeControlService } from "./tree-control.service";
import { TreeNode } from "./tree-node";
import * as _ from 'lodash';

@Injectable()
export class TreeDataSourceService
  extends DataSource<TreeNode>
  implements OnDestroy
{
  public treeControl: TreeControlService;

  _expandedData = new BehaviorSubject<TreeNode[]>([]);
  _nodesMap: { [key in string]: TreeNode };

  private subscriptions: Subscription[] = [];

  constructor(private storageList: TreeListService) {
    super();
  }

  ngOnDestroy() {}

  connect(collectionViewer: CollectionViewer): Observable<TreeNode[]> {
    const changes = [
      collectionViewer.viewChange,
      this.treeControl.expansionModel.changed,
      this.storageList.nodesSubject,
    ] as any[];
    return merge(...changes).pipe(
      map(() => {
        this._expandedData.next(this._expandedNodes);
        return this._expandedData.value;
      })
    );
  }

  disconnect() {
    // no op
  }

  init(items) {
    this.storageList.init(items);
    this.subscriptions.push(
      this.storageList.nodesSubject.subscribe((nodes) => (this.data = nodes))
    );
  }

  get data() {
    return this.storageList.nodes;
  }

  set data(nodes: TreeNode[]) {
    this.treeControl.dataNodes = nodes;
  }

  /**
   * Expand flattened node with current expansion status.
   * The returned list may have different length.
   */
  get _expandedNodes(): TreeNode[] {
    const results: TreeNode[] = [];
    const currentExpand: boolean[] = [];
    currentExpand[0] = true;

    this.data.forEach((node) => {
      const depth = node.level - 1;
      let expand = true;
      for (let i = 0; i <= depth; i++) {
        expand = expand && currentExpand[i];
      }
      if (expand) {
        results.push(node);
      }
      if (node.expandable === true) {
        currentExpand[depth + 1] = this.treeControl.isExpanded(node);
      }
    });
    return results;
  }

  findIndex(node: TreeNode): number {
    const nodes = this._expandedData.getValue();
    return _.findIndex(nodes, (current: TreeNode) => current.path === node.path);
  }
}
